import { DraggableTypesEnum } from 'constants/builder/enums';
import { v4 as generateId } from 'uuid';

import type { QuestionnaireItems } from '../types';

export const addParagraphHelper = (
    questions: QuestionnaireItems,
    paragraphs: any[],
    clauseId: string,
    blockId: string,
    contentId: string,
    isShown?: boolean
) => {
    const fields = paragraphs
        .flat()
        .flatMap(item => item.modifiedData)
        .filter(item => item.id);

    if (!fields.length) {
        const itemsForDeleting = questions.filter(
            item =>
                item.clauseId === clauseId &&
                item.contentId === contentId &&
                item.questionType === DraggableTypesEnum.Field
        );

        return questions.filter(item => !itemsForDeleting.find(question => question.id === item.id));
    }

    const allFieldQuestions = questions.filter(item => item.questionType === DraggableTypesEnum.Field);

    questions.forEach((item, index) => {
        fields.forEach(field => {
            if (field.fieldId === item.fieldId) {
                questions.splice(index, 1);
                questions.splice(index, 0, {
                    questionType: DraggableTypesEnum.Field,
                    description: field.description,
                    entityProps: field.entityProps,
                    subtitle: field.question,
                    title: field.placeholder,
                    fieldId: field.fieldId,
                    value: field.value,
                    type: field.type,
                    id: generateId(),
                    contentId,
                    clauseId,
                    blockId,
                    isShown
                });
            }
        });
    });

    fields.forEach(item => {
        if (
            !allFieldQuestions.find(field => field.fieldId === item.fieldId) &&
            !allFieldQuestions.some(field => field.title.trim() === item.placeholder?.trim())
        ) {
            questions.push({
                questionType: DraggableTypesEnum.Field,
                entityProps: item.entityProps,
                description: item.description,
                subtitle: item.question,
                title: item.placeholder,
                fieldId: item.fieldId,
                value: item.value,
                id: generateId(),
                type: item.type,
                contentId,
                clauseId,
                blockId,
                isShown
            });
        }
    });

    return questions;
};
